package io.horion.cv.components.forms

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.styleModifier
import io.horion.cv.api.datasource.cv.Reference
import io.horion.cv.components.cards.GenericFormCard
import io.horion.cv.components.cards.SummaryData
import io.horion.cv.components.widgets.AddButton
import io.horion.cv.di.koinGet
import io.horion.cv.models.ReferenceState
import io.horion.cv.viewModel.CvViewModel
import org.jetbrains.compose.web.css.px

@Composable
fun ReferenceAccordionContent(
    onComplete: (String) -> Unit,
    onAddReferenceAndClose: (String) -> Unit,
) {
    val cvViewModel = koinGet<CvViewModel>()
    val referencesFromVM = cvViewModel.cvUiState.data.references

    LaunchedEffect(Unit) {
        if (referencesFromVM.isEmpty()) {
            cvViewModel.updateReference(0, Reference("", "", "", "", ""))
            cvViewModel.editingReferenceId = "reference-0"
        }
    }

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .styleModifier {
                property("box-sizing", "border-box")
                property("min-width", "0")
            },
        verticalArrangement = Arrangement.spacedBy(30.px),
    ) {
        referencesFromVM.forEachIndexed { index, ref ->
            val tempId = "reference-$index"

            val referenceState = remember(ref) {
                ReferenceState(
                    id = tempId,
                    nom = ref.name,
                    entreprise = ref.enterprise,
                    ville = ref.city,
                    telephone = ref.phone,
                    mail = ref.email
                )
            }

            GenericFormCard(
                item = referenceState,
                isEditing = cvViewModel.editingReferenceId == tempId,
                onEdit = { cvViewModel.editingReferenceId = tempId },
                onDelete = {
                    cvViewModel.deleteReference(index)
                    if (cvViewModel.cvUiState.data.references.isEmpty()) {
                        cvViewModel.updateReference(0, Reference("", "", "", "", ""))
                        cvViewModel.editingReferenceId = "reference-0"
                    } else {
                        cvViewModel.editingReferenceId = null
                    }
                },
                onComplete = { cvViewModel.editingReferenceId = null },
                getSummary = { r ->
                    if (r.nom.isNotBlank() || r.entreprise.isNotBlank()) {
                        SummaryData(
                            title = r.nom.ifBlank { "[Nom]" },
                            subtitle = r.entreprise.ifBlank { "[Entreprise]" }
                        )
                    } else null
                },
                getDefaultText = { "[Références]" },
                formContent = { state, onDel, onComp ->
                    ReferenceForm(
                        index = index,
                        state = state,
                        cvViewModel = cvViewModel,
                        onDelete = onDel,
                        onComplete = onComp,
                    )
                }
            )
        }

        AddButton(
            text = "Ajouter une référence",
            onClick = {
                val nextIndex = referencesFromVM.size
                cvViewModel.updateReference(nextIndex, Reference("", "", "", "", ""))
                cvViewModel.editingReferenceId = "reference-$nextIndex"
            }
        )
    }
}